import { NavigationItem, SEPARATOR, Separator } from '../../../data/types';
import { createTag } from '../../../utils/tag-creators';
import { DropdownArrow } from './DropdownArrow/DropdownArrow';
import * as s from './Navigation.scss';
import { SubMenu } from './SubMenu';

export interface MenuItemProps {
  item: NavigationItem | Separator;
  t(key: string): string;
  language: string;
}

export const MainMenuItemButton = ({ item, t, language }: MenuItemProps, id: string) => {
  if (item === SEPARATOR) {
    return ``;
  }
  if (item.href) {
    return createTag('a', t(item.text), {
      class: `${s.link}`,
      target: item.target,
      href: item.href,
      role: language === 'en' ? 'menuitem' : undefined,
      'data-bi-name': item.name,
      'data-bi-row': 'first',
    });
  }

  return `
    <a
      id="${id}"
      class="${s.link} ${s.mainMenuButton}"
      data-bi-name="${item.name}"
      data-bi-row="first"
      data-toggle="collapse"
      aria-expanded="false"
      role="button"
      href="#"
    >
      ${t(item.text)}
      ${item.subs?.length ? DropdownArrow(s.arrow) : ''}
    </a>
  `;
};

export const MainMenuItem = ({ item, t, language }: MenuItemProps) => {
  const dataHook = 'wix-header-main-menu-item';
  if (item === SEPARATOR) {
    return `<li class="${s.menuItemSeparator}" aria-hidden="true" data-hook="${dataHook}"></li>`;
  }
  const id = `main-menu-item-${item.name}`;
  return `
    <li
      class="${s.menuItem} ${s.mainMenuItem} ${item.mobileOnly ? s.mobileOnly : ''}"
      data-hook="${dataHook}"
      ${item.subs?.length ? 'data-expanded="false"' : ''}
    >
      <div class="${s.linkWrapper}">
        ${MainMenuItemButton({ item, t, language }, id)}
      </div>
      ${item.subs ? SubMenu({ labelledBy: id, items: item.subs, t, language }) : ''}
    </li>
  `;
};
